// @flow

import { connect } from 'react-redux';
import * as Selectors from '../selectors';
import HomePage from '../components/pages/home';

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    myReports: Selectors.getMyReports(state) || [],
    orgReports: Selectors.getOrgReports(state) || [],
  };
}

export default connect(mapStateToProps)(HomePage);
